// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sticky[data-v-bde1c824]:after{background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff 55%);bottom:-1.25rem;content:\"\";display:block;height:8rem;left:-1.25rem;position:absolute;right:-1.25rem}@media (min-width:640px){.sticky[data-v-bde1c824]:after{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
